import { authorityMutation } from '../mutations/authority'
import { authorityAction } from '../actions/authority'

export const authority = {
  state: {
    isLogining: false,
    isLogouting: false,
    logged: false,
    isreg: false,
    loginSuccess: false,
    loginFailure: false,
    logoutSuccess: false,
    logoutFailure: false,
    isforget: false,
    userInfo: {},
    msg: ''
  },
  mutations: authorityMutation,
  actions: authorityAction
}
